<template>
  <v-alert
    text
    :dismissible="items.dismissable"
    :color="items.text_color"
    :width="items.width"
    class="text-sm-body-1 font-weight-regular mb-2 alert"
  >
    <div class="d-flex flex-md-row flex-column">
      <div>
        <strong>{{ items.strong_text }}</strong
        >{{ items.text }}
      </div>
      <v-btn
        v-if="items.button !== undefined"
        :loading="loader"
        :disabled="button"
        max-width="214px"
        @click="onSend(items.body)"
        class="ml-md-auto success rounded text-sm-body-1 font-weight-regular"
      >
        {{ items.button }}</v-btn
      >
    </div>
  </v-alert>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["items"],

  data() {
    return {
      button: false,
      loader: false,
    };
  },

  methods: {
    ...mapActions(["sendReminder"]),

    async onSend(body) {
      try {
        this.loader = true;
        await this.sendReminder({
          body: {
            ReportPeriodId: body.ReportPeriodId,
            CreditInstituteId: body.CreditInstituteId,
          },
        });
        this.loader = false;
        this.items.strong_text = "Επιτυχία! ";
        this.items.text_color = "success";
        this.items.text = `   Ο ΑΕΔΑΚ ${this.items.body.creditInstituteName} ειδοποιήθηκε με email.`;
        this.button = true;
      } catch (e) {
        this.loader = false;
      }
    },
  },
};
</script>

<style scoped lang="scss" >
</style>